import moment from 'moment';
import { MessageBox } from 'element-ui';
import { merge } from 'loadsh';
import da from "element-ui/src/locale/lang/da";

const  DEFAULT_DATE_PATTERN = 'YYYY-MM-DD', BUTTON_PERMISSION_CACHE = [];

function datePatternHandler(pattern) {
    let arr = pattern.split(' ');

    arr[0] = arr[0].split('-').map(item => item.toUpperCase()).join('-');

    return arr.join(' ');
}

const methods = {
    saveToken2LocalStorage (response){
        //有效期设置为过期时间提前1分钟
        this.$token.setToken(`${response.data.token_type} ${response.data.access_token}`, Number(Date.now() + response.data.expires_in * 1000 - 60 * 1000));

        this.$token.setRefreshToken(response.data.refresh_token);
    },

    calcDaysByDateRange (startDate, endDate){
        if(!startDate || !endDate){
            return 0;
        }

        let s = new Date(startDate).getTime(),
            e = new Date(endDate).getTime(),
            v = (e - s) / (1000 * 60 * 60 * 24);

        return v < 0 ? v - 1 : v + 1;
    },

    formatMoney(val, addComma = true) {
        let comma = addComma ? ',' : '';

        val=val/100;
        val = val.toString().replace(/\$|\,/g,'');
        if(isNaN(val)) {
            val = "0";
        }
        let sign = (val == (val = Math.abs(val)));
        val = Math.floor(val*100+0.50000000001);
        let cents = val%100;
        val = Math.floor(val/100).toString();
        if(cents<10) {
            cents = "0" + cents
        }
        for (let i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
            val = val.substring(0,val.length-(4*i+3))+comma + val.substring(val.length-(4*i+3));
        }

        return (((sign)?'':'-') + val + '.' + cents);
    },

    formatDate (date, format = DEFAULT_DATE_PATTERN){
        return moment(date).format(datePatternHandler(format));
    },

    /**
     * 获取最大日期
     * @param dateList
     * @return {*}
     */
    getMaxDateByDateList (dateList){
        return this.getDateByDateList(dateList);
    },

    /**
     * 获取最小日期
     * @param dateList
     * @return {*}
     */
    getMinDateByDateList (dateList){
        return this.getDateByDateList(dateList, 'min');
    },

    /**
     * 获取一个list中的某个日期
     * @param dateList
     * @param type
     * @return {*}
     */
    getDateByDateList (dateList, type = 'max'){
        if(dateList instanceof Array){
            return this.formatDate(dateList.reduce(function (maxDate, current) {
                let cd = new Date(current),
                    arr = [maxDate, cd];

                type === 'max' && arr.reverse();

                if(arr[0] > arr[1]){
                    return cd;
                }

                return maxDate;
            }, new Date(dateList[0])));
        }

        return undefined;
    },

    formatTreeSelectData (responseData){
        return handleData.call(this, responseData || []);

        function handleData(source) {
            if(!this.listNotEmpty(source)) return;

            return source.map(item => {
                item.label = item.name;

                item.children = handleData.call(this, item.children);

                return item;
            });
        }
    },

    deleteConfirm (callback, message = '是否删除该项？', title = '提示'){
        this.operateConfirm(callback, message, title);
    },

    operateConfirm (callback, message = '是否继续操作？', title = '提示'){
        MessageBox.confirm(message, title, {
            type: 'warning',
            closeOnClickModal: false
        }).then(callback).catch(() => {});
    },

    addYear (year, add = 1, format = DEFAULT_DATE_PATTERN){
        return moment(year).add(add, 'y').add(-1, 'd').format(datePatternHandler(format));
    },

    addMonth (date, add = 1, format = DEFAULT_DATE_PATTERN){
        return moment(date).add(add, 'M').add(-1, 'd').format(datePatternHandler(format));
    },

    addDay (date, add = 1, format = DEFAULT_DATE_PATTERN){
        return moment(date).add(add, 'd').format(datePatternHandler(format));
    },

    diffYear (endDate, startDate){
        let eD = moment(endDate).add(1, 'd').format('MM-DD'),
            sD = moment(startDate).format('MM-DD');

        if(eD === sD){
            return moment(endDate).diff(moment(startDate), 'y') + 1;
        }
    },

    sexFormatter (sex){
        return {
            0: '女',
            1: '男'
        }[parseInt(sex || '0')];
    },

    /**
     * 价格单位格式化
     * @param status
     * @returns {*}
     */
    priceUnitFormatter(status) {
        return {
            "py-r": "元/m²/日",
            "y-r": "元/日",
            "py-y": "元/m²/月",
            "y-y": "元/月",
            "py-j": "元/m²/季",
            "y-j": "元/季",
            "py-bn": "元/m²/半年",
            "y-bn": "元/半年",
            "py-n": "元/m²/年",
            "y-n": "元/年",
            "gy-r": "元/个/日",
            "gy-y": "元/个/月",
            "gy-j": "元/个/季",
            "gy-bn": "元/个/半年",
            "gy-n": "元/个/年"
        }[status];
    },

    /**
     * 绑定附件类型
     * @param target
     * @param type
     */
    bindAttachmentType (target, type){
        if(!target) return target;

        if(target instanceof Array){
            return target.map(item => Object.assign({}, item, {type}));
        }else{
            return Object.assign({}, target || {}, {type});
        }
    },

    /**
     * 根据附件类型过滤附件
     * @param target
     * @param type
     */
    getAttachmentByType (target, type){
        if(target instanceof Array){
            return target.filter(item => item.type === type);
        }else{
            return target;
        }
    },

    /**
     * 获取下个自然月开始日期
     * @param date
     * @param add
     */
    getNextNaturalMonth (date, add = 1){
        return moment(date).startOf('month').add(add, 'M').format(DEFAULT_DATE_PATTERN);
    },

    /**
     * 获取下个租赁月开始日期
     * @param date
     * @param add
     */
    getNextLeaseMonth (date, add = 1){
        return moment(date).add(add, 'M').format(DEFAULT_DATE_PATTERN);
    },

    /**
     * 判断数字是否为空
     * @param num {Number}
     * @returns {boolean}
     */
    numIsEmpty (num){
        return ['', undefined, null].includes(num);
    },

    /**
     * 格式化金额 根据保留位
     * @param money {Number}
     * @return {Number}
     */
    formatMoneyByReservedBit (money){
        return money ? this.toFixed(money, 2, true) : money;
    },

    /**
     * 使用定点表示法来格式化一个数
     * @param  {String|Number}  num     [必选，数字或者表示数字的字符串,范围为[0,20],超过范围则报错]
     * @param  {Number}  digits  [必选，小数点后数字的个数]
     * @param  {Boolean} isRound [可选，格式化时是否四舍五入，默认为false，即进行四舍五入,为false时直接截取，不满足位数的往后补0]
     * @return {String}          [结果]
     */
    toFixed(num, digits, isRound) {
        // 是否为正数
        let isPositive = (+num >= 0);
        num += '';

        isRound = Boolean(isRound);
        // 去掉正负号，统一按照正数来处理，最后再加上符号
        num = num.replace(/^(?:-|\+)/gi, '');

        // 小数点过大
        /* istanbul ignore next */
        if (digits > 20 || digits < 0) {
            throw new RangeError('toFixed() digits argument must be between 0 and 20');
        }

        // 如果是简写如.11则整数位补0，变成0.11
        /* istanbul ignore next */
        if (/^\./gi.test(num)) {
            num = '0' + num;
        }

        // 非数字
        /* istanbul ignore next */
        if (!/^\d+\.?\d*$/gi.test(num)) {
            throw new Error('toFixed() num argument must be a valid num');
        }

        let numParts = num.split('.');
        let result = '';
        let floatPart = '';

        // 在str后面加n个0
        let _paddingZero = function (str, n) {
            for (let i = 0; i < n; i++) {
                str += '0';
            }
            return str;
        };

        // 在str后面加0，直至str的长度达到n
        // 如果超过了n，则直接截取前n个字符串
        let _paddingZeroTo = function (str, n) {
            if (str.length >= n) {
                return str.substr(0, n);
            } else {
                return _paddingZero(str, n - str.length);
            }
        };

        // 直接就是整数
        if (numParts.length < 2) {
            result = numParts[0] + '.' + _paddingZero('', digits);
            // 为浮点数
        } else {
            // 如果为截取
            if (isRound === false) {
                result = numParts[0] + '.' + _paddingZeroTo(numParts[1], digits);
                // 如果为四舍五入
            } else {
                // 放大10的N次方倍
                let enlarge = numParts[0] + _paddingZeroTo(numParts[1], digits) + '.' + numParts[1].substr(digits);
                // 取整
                enlarge = Math.round(enlarge) + '';
                // 缩小10的N次方
                while(enlarge.length <= digits){
                    enlarge = '0' + enlarge;
                }
                result = enlarge.substr(0, enlarge.length - digits) + '.' + enlarge.substr(enlarge.length - digits);
            }
        }

        // 如果最后一位为.,则去除
        result = result.replace(/\.$/gi, '').replace(/^\./gi, '0.');

        // 加上符号位
        result = isPositive ? result : '-' + result;

        return Number(result);
    },

    /**
     * 改变路由参数
     * @param param
     * @param value
     * @param isEncrypt
     */
    changeRouteParam (param, value, isEncrypt = true){
        function mergeParamFunc(params) {
            if(isEncrypt){
                return this.$routerParamsEncrypt(params);
            }else{
                return params;
            }
        }

        this.$jump({
            name: this.$route.name,
            query: this.$route.query,
            params: mergeParamFunc.call(this, Object.assign({}, this.$routeParams || {}, {
                [param]: value
            })),
        });
    },

    /**
     * list不为空
     * @param list
     * @return {boolean}
     */
    listNotEmpty (list){
        return list && list.length > 0;
    },

    /**
     * map不能为空
     * @param map
     * @param valueNotEmpty
     * @return {boolean}
     */
    mapNotEmpty (map, valueNotEmpty = false){
        let keys = map ? Object.keys(map) : [];

        if(valueNotEmpty){
            return keys.filter(key => !map[key] || this.numIsEmpty(map[key])).length === 0;
        }

        return keys.length > 0;
    },

    /**
     * 深copy对象
     * @return {*}
     */
    cloneDeep: function () {
        return merge(...Array.from(arguments || []).reverse());
    },

    /**
     * 获取当前季度的开始结束日期
     * @param dateStr
     */
    getCurrentQuarterSection (dateStr){
        let date = moment(dateStr),
            currentQuarter = date.quarter(), // 当前是第几季度
            currentYear = date.year(), // 当前年
            startDate = moment(moment(currentYear + '-01-01').toDate()).quarter(currentQuarter).format(DEFAULT_DATE_PATTERN); //当前季度开始日期

        let endMonth = 3 * currentQuarter; //当季度最后一个月
        /* 对月数进行格式化 */
        if(endMonth < 10)
            endMonth = '0' + endMonth;
        else
            endMonth += '';

        let endMonthDays = moment(currentYear + '-' + endMonth).daysInMonth(); // 末尾月天数
        let endDays = currentYear + '-' + endMonth + '-' + endMonthDays; //完整年月日整合

        let endDate = moment(endDays).format(DEFAULT_DATE_PATTERN); // 计算结果

        return { startDate, endDate };
    },

    /**
     * 获取这个季度的天数
     * @param dateStr
     * @return {number|*}
     */
    getCurrentQuarterDays (dateStr){
        let { startDate, endDate } = this.getCurrentQuarterSection(dateStr);

        return this.calcDaysByDateRange(startDate, endDate);
    },

    /**
     * 获取当前半年区间的开始结束日期
     * @param dateStr
     */
    getCurrentHalfAYearSection (dateStr){
        let date = new Date(dateStr),
            year = date.getFullYear(),
            month = date.getMonth() + 1;
        if(month < 7){
            return { startDate: year + '-01-01', endDate: year + '-06-30'}
        }

        return { startDate: year + '-07-01', endDate: year + '-12-31' };
    },

    /**
     * 获取当前年区间的开始结束日期
     * @param dateStr
     * @return {{endDate: string, startDate: string}}
     */
    getCurrentYearSection (dateStr){
        let year = new Date(dateStr).getFullYear();

        return { startDate: year + '-01-01', endDate: year + '-12-31'}
    },

    /**
     * 检测日期是否在区间内
     * @param date
     * @param startDate
     * @param endDate
     * @return {boolean}
     */
    dateIsBetween (date, startDate, endDate){
        return moment(date).isBetween(moment(startDate), moment(endDate));
    },

    /**
     * 获取当前月份的日期区间
     * @param dateStr
     * @return {string}
     */
    getCurrentMonthSection (dateStr){
        return {
            startDate: moment(dateStr).startOf('month').format(DEFAULT_DATE_PATTERN),
            endDate: moment(dateStr).endOf('month').format(DEFAULT_DATE_PATTERN)
        };
    },

    /**
     * 获取两个日期之间所有的月份
     * @param startDate
     * @param endDate
     * @param isLease
     * @param contractStartDate
     */
    getMonthList (startDate, endDate, isLease = false, contractStartDate){
        let monthList = [],
            endTime = new Date(endDate).getTime();

        if(isLease){
            if(!contractStartDate) throw new Error('请传入合同开始日期');

            let sd = [new Date(startDate).format('yyyy-MM'), new Date(contractStartDate).format('dd')].join('-');

            const getSection = s => {
                return {startDate: s, endDate: this.addMonth(s)};
            };

            let section = getSection(sd);

            for (; new Date(section.startDate).getTime() < endTime ; section = getSection(this.addDay(section.endDate))) {
                monthList.push(section);
            }
        }else{
            let section = this.getCurrentMonthSection(startDate);

            for (; new Date(section.startDate).getTime() < endTime ; section = this.getCurrentMonthSection(this.addDay(section.endDate))) {
                monthList.push(section);
            }
        }

        return monthList;
    },

    /**
     * 判断是否为租赁月或自然月
     * @param s
     * @param e
     * @return {number} 1是一个租赁/自然月 0小于一个租赁/自然月 2大于一个租赁/自然月
     */
    checkIsMonth (s, e){
        let { startDate, endDate } = this.getCurrentMonthSection(s);

        if(s === startDate && e === endDate){ //一个自然月
            return 1;
        }else{
            let sd = new Date(s), ed = new Date(e),
                month = ed.getMonth() - sd.getMonth(),
                year = ed.getFullYear() - sd.getFullYear();

            //结束日期跨年了
            if(year > 0){
                if(year > 1){
                    return 2;
                }else{
                    if(month <= 0){
                        month = 12 + month;
                    }
                }
            }

            if(month === 1){
                if(sd.getDate() - 1 === ed.getDate()){
                    return 1;
                }else if(sd.getDate() - 1 < ed.getDate()){
                    return 2;
                }else{
                    return 0;
                }
            }else if(month > 1){
                return 2;
            }else{
                return 0;
            }
        }
    },

    /**
     * 获取两个日期之间的季度
     * @param startDate
     * @param endDate
     * @param isLease 是否是租赁季
     * @param contractStartDate 合同开始日期 租赁季时需要使用
     * @return {[]}
     */
    getQuarterList (startDate, endDate, isLease = false, contractStartDate){
        let quarterList = [],
            endTime = new Date(endDate).getTime();

        if(isLease){
            if(!contractStartDate) throw new Error('请传入合同开始日期');

            let sd = [new Date(startDate).format('yyyy-MM'), new Date(contractStartDate).format('dd')].join('-');

            const getSection = s => {
                return {startDate: s, endDate: this.addMonth(s, 3)};
            };

            let section = getSection(sd);

            for (; new Date(section.startDate).getTime() < endTime ; section = getSection(this.addDay(section.endDate))) {
                quarterList.push(section);
            }
        }else{
            let section = this.getCurrentQuarterSection(startDate);

            for (; new Date(section.startDate).getTime() < endTime ; section = this.getCurrentQuarterSection(this.addDay(section.endDate))) {
                quarterList.push(section);
            }
        }

        return quarterList;
    },

    /**
     * 判断是否为租赁季或自然季
     * @param s
     * @param e
     * @return {number} 1是一个租赁/自然季度 0小于一个租赁/自然季度 2大于一个租赁/自然季度
     */
    checkIsQuarter (s, e){
        let { startDate, endDate } = this.getCurrentQuarterSection(s);

        if(s === startDate && e === endDate){ //一个自然季度
            return 1;
        }else{
            let sd = new Date(s), ed = new Date(e),
                month = ed.getMonth() - sd.getMonth(),
                year = ed.getFullYear() - sd.getFullYear();

            //结束日期跨年了
            if(year > 0){
                if(year > 1){
                    return 2;
                }else{
                    if(month <= 0){
                        month = 12 + month;
                    }
                }
            }

            if(month === 3){ //一个季度
                if(sd.getDate() - 1 === ed.getDate()){
                    return 1;
                }else if(sd.getDate() - 1 < ed.getDate()){
                    return 2;
                }else{
                    return 0;
                }
            }else if(month > 3){
                return 2;
            }else{
                return 0;
            }
        }
    },

    /**
     * 获取两个日期之间的半年
     * @param startDate
     * @param endDate
     * @param isLease 是否是租赁半年
     * @param contractStartDate 合同开始日期 租赁半年时需要使用
     * @return {[]}
     */
    getHalfAYearList (startDate, endDate, isLease = false, contractStartDate){
        let halfAYearList = [],
            endTime = new Date(endDate).getTime();

        if(isLease){
            if(!contractStartDate) throw new Error('请传入合同开始日期');

            let sd = [new Date(startDate).format('yyyy-MM'), new Date(contractStartDate).format('dd')].join('-');

            const getSection = s => {
                return {startDate: s, endDate: this.addMonth(s, 6)};
            };

            let section = getSection(sd);

            for (; new Date(section.startDate).getTime() < endTime ; section = getSection(this.addDay(section.endDate))) {
                halfAYearList.push(section);
            }
        }else{
            let section = this.getCurrentHalfAYearSection(startDate);

            for (; new Date(section.startDate).getTime() < endTime ; section = this.getCurrentHalfAYearSection(this.addDay(section.endDate))) {
                halfAYearList.push(section);
            }
        }

        return halfAYearList;
    },

    /**
     * 判断是否为租赁半年或自然半年
     * @param s
     * @param e
     * @return {number} 1是一个租赁/自然半年 0小于一个租赁/自然半年 2大于一个租赁/自然半年
     */
    checkIsHalfAYear (s, e){
        let { startDate, endDate } = this.getCurrentHalfAYearSection(s);

        if(s === startDate && e === endDate){ //一个自然半年
            return 1;
        }else{
            let sd = new Date(s), ed = new Date(e),
                month = ed.getMonth() - sd.getMonth(),
                year = ed.getFullYear() - sd.getFullYear();

            //结束日期跨年了
            if(year > 0){
                if(year > 1){
                    return 2;
                }else{
                    if(month <= 0){
                        month = 12 + month;
                    }
                }
            }

            if(month === 6){ //一个半年
                if(sd.getDate() - 1 === ed.getDate()){
                    return 1;
                }else if(sd.getDate() - 1 < ed.getDate()){
                    return 2;
                }else{
                    return 0;
                }
            }else if(month > 6){
                return 2;
            }else{
                return 0;
            }
        }
    },

    /**
     * 获取两个日期之间的年
     * @param startDate
     * @param endDate
     * @param isLease 是否是租赁年
     * @param contractStartDate 合同开始日期 租赁年时需要使用
     * @return {[]}
     */
    getYearList (startDate, endDate, isLease = false, contractStartDate){
        let yearList = [],
            endTime = new Date(endDate).getTime();

        if(isLease){
            if(!contractStartDate) throw new Error('请传入合同开始日期');

            let sd = [new Date(startDate).format('yyyy-MM'), new Date(contractStartDate).format('dd')].join('-');

            const getSection = s => {
                return {startDate: s, endDate: this.addYear(s)};
            };

            let section = getSection(sd);

            for (; new Date(section.startDate).getTime() < endTime ; section = getSection(this.addDay(section.endDate))) {
                yearList.push(section);
            }
        }else{
            let section = this.getCurrentYearSection(startDate);

            for (; new Date(section.startDate).getTime() < endTime ; section = this.getCurrentYearSection(this.addDay(section.endDate))) {
                yearList.push(section);
            }
        }

        return yearList;
    },

    /**
     * 判断是否为租赁年或自然年
     * @param s
     * @param e
     * @return {number} 1是一个租赁/自然年 0小于一个租赁/自然年 2大于一个租赁/自然年
     */
    checkIsYear (s, e){
        let { startDate, endDate } = this.getCurrentYearSection(s);

        if(s === startDate && e === endDate){ //一个自然年
            return 1;
        }else{
            let sd = new Date(s), ed = new Date(e),
                month = ed.getMonth() - sd.getMonth(),
                year = ed.getFullYear() - sd.getFullYear();

            //结束日期跨年了
            if(year > 0){
                if(year > 1){
                    return 2;
                }else{
                    if(month < 0){
                        month = 12 + month;
                    }
                }
            }

            if(month === 12){ //一个年
                if(sd.getDate() - 1 === ed.getDate()){
                    return 1;
                }else if(sd.getDate() - 1 < ed.getDate()){
                    return 2;
                }else{
                    return 0;
                }
            }else if(month > 12){
                return 2;
            }else{
                return 0;
            }
        }
    },

    /**
     * 根据code加载字典
     * @param dictCode
     * @param callback
     * @return {boolean}
     */
    loadDictByCode (dictCode, callback){
        if(!dictCode) return !this.$warn('请传入字典编码');

        this.$api('dict', 'queryByCode', {
            code: dictCode
        }).then(response => {
            let dictMap = (response.data || []).reduce(function (result, current) {
                return Object.assign({}, result, {
                    [current.code]: current.name
                });
            }, {});

            callback && callback(dictMap);
        });
    },

    /**
     * 计算合同进度
     * @param row
     */
    handleContractProgress (row){
        let { startDate, endDate } = row,
            totalDays = this.calcDaysByDateRange(startDate, endDate),
            startTime = new Date(startDate).getTime(),
            endTime = new Date(endDate).getTime(),
            currentDays;

        if(row.state === 'zxz'){
            if(startTime <= Date.now()){
                if(Date.now() <= endTime){
                    currentDays = this.calcDaysByDateRange(startDate, new Date().format());
                }else{
                    currentDays = totalDays;
                }

                return this.toFixed(currentDays / totalDays * 100, 2, true);
            }

            return 1;
        }else{
            return 1;
        }
    },

    /**
     * 查看房屋
     * @param room
     */
    handleSeeRoom(room) {
        window.open('/zcgl/fjgl/detail/' + this.$routerParamsEncrypt({id: room.id}).routeParams, '_blank')
    },

    /**
     * 查看合同
     * @param item
     */
    handleSeeContract (item){
        window.open('/htgl/htlb/detail/' + this.$routerParamsEncrypt({id: item.id}).routeParams, '_blank');
    },

    /**
     * 获取json里的某个字段
     * @param jsonStr
     * @param field
     * @return {*}
     */
    getJsonValue (jsonStr, field){
        try {
            return JSON.parse(jsonStr)[field];
        }catch (e) {}
    },

    /**
     * 把json转换为object
     * @param jsonStr
     */
    json2Object (jsonStr){
        try {
            return jsonStr ? JSON.parse(jsonStr) : jsonStr;
        } catch (e) {
            return jsonStr;
        }
    },

    /**
     * 把object转换为json
     * @param jsonStr
     */
    object2Json (jsonStr){
        try {
            return jsonStr ? JSON.stringify(jsonStr) : jsonStr;
        } catch (e) {
            return jsonStr;
        }
    },

    /**
     * 数字相加
     * @param nums
     */
    numberAdd (...nums){
        return (nums || []).reduce(function (total, current) {
            return total += Number(String(current || '0').replace(new RegExp(',', "g"), ''));
        }, 0);
    }
};

/**
 * 格式化日期
 * @param pattern 格式
 * @return {string}
 */
Date.prototype.format = function (pattern = DEFAULT_DATE_PATTERN){
    return methods.formatDate(this, datePatternHandler(pattern));
};

/**
 * 将数组拆分为指定数量一组
 * @param chunkLength 几个一组
 * @return {[]}
 */
Array.prototype.chunk = function (chunkLength) {
    let result = [];
    for(let i=0; i<this.length; i=i+chunkLength){
        result.push(this.slice(i, i+chunkLength));
    }
    return result;
};

/**
 * 将数组拆分为指定数量一组(倒序排列)
 * @param chunkLength 几个一组
 * @return {*[]}
 */
Array.prototype.chunkDesc = function (chunkLength) {
    let result = [];
    for(let i=this.length; i>=0; i=i - chunkLength){
        let startIndex = i - chunkLength;

        result.push(this.slice(startIndex < 0 ? 0 : startIndex, i));
    }
    return result.reverse();
};

/**
 * 拼接字符串，并且过滤空串
 * @param connectorStr
 */
Array.prototype.joinNotEmpty = function (connectorStr = '/'){
    return this.filter(item => !!item).join(connectorStr) || '';
};

/**
 * 获取最后一个
 * @return {*}
 */
Array.prototype.last = function (){
    return this[this.length  -1] || {};
};

/**
 * 移动元素顺序
 * @param oldIndex
 * @param newIndex
 */
Array.prototype.move = function (oldIndex, newIndex){
    let cp = [].concat(...this);

    cp[oldIndex] = cp.splice(newIndex, 1, cp[oldIndex])[0];

    this.splice(0, this.length, ...cp);
}

/**
 * 补齐字符串左边位数
 * @param total 总长度
 * @param pad 补齐字符串
 */
String.prototype.padLeft =
    Number.prototype.padLeft = function(total, pad) {
        return (Array(total).join(pad || 0) + this).slice(-total);
    };

export default methods;



// WEBPACK FOOTER //
// ./src/configure/methods/index.js